export default __webpack_public_path__ + "static/media/vernier-calliper.b2f14367.jpg";